import * as models from '../models'
import ModelFactory from '@shared/model/ModelFactory'
import { TModelObjects } from '@shared/model/$modelsLoader'

/**
 * load default Models
 */
const modelObjects: TModelObjects = Object.keys(models).reduce((ret, modelName) => {
  const modelDefinition = models[modelName]
  ret[modelName] = new ModelFactory(modelName, modelDefinition)
  return ret
}, {} as TModelObjects)

export const $models = modelObjects
